// export const ENDPOINT = "http://localhost:5052/v1/";
// export const IMAGEBASEPATH = "http://localhost:5052/file/";
// export const ENDPOINT = "http://144.217.254.136:5052/v1/";
// export const IMAGEBASEPATH = "http://144.217.254.136:5052/file/";
export const ENDPOINT = "https://imindyou.com/album/v1/";
export const IMAGEBASEPATH = "https://imindyou.com/album/file/";